class Creditor{
    public id: number;
    public name_creditor: string;
    public type_creditor: string;
    public id_municipality: string;
    public document_creditor: string;
    public address_creditor: string;
    public phone_creditor: string;
    public email_creditor: string;
    public is_active: string;
    public name_municipality! : string;
    constructor(
        id: number,
        name_creditor: string,
        type_creditor: string,
        id_municipality: string,
        document_creditor: string,
        address_creditor: string,
        phone_creditor: string,
        email_creditor: string,
        is_active: string,
    ){
        this.id = id;
        this.name_creditor = name_creditor;
        this.type_creditor = type_creditor;
        this.id_municipality = id_municipality;
        this.document_creditor = document_creditor;
        this.address_creditor = address_creditor;
        this.phone_creditor = phone_creditor;
        this.email_creditor = email_creditor;
        this.is_active = is_active;
    }
  }
  
  export default Creditor;
  